// Isolated theme hook for knowledge base - does not use application contexts
import { useState, useEffect } from 'react';

export type KBThemeMode = 'light' | 'dark';

export const useKBTheme = () => {
  const getInitialMode = (): KBThemeMode => {
    try {
      const stored = localStorage.getItem('kb_theme_mode');
      if (stored === 'light' || stored === 'dark') return stored;
    } catch {}
    if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
    return 'light';
  };

  const [mode, setMode] = useState<KBThemeMode>(getInitialMode);

  useEffect(() => {
    try {
      localStorage.setItem('kb_theme_mode', mode);
    } catch {}
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-theme', mode);
    }
  }, [mode]);

  const toggleMode = () => {
    setMode((m) => (m === 'light' ? 'dark' : 'light'));
  };

  return { mode, toggleMode };
};








